import { TableSortOrderType } from '../enums/table-sort-order-type';

export class TableSort {
  public constructor(
    public readonly field: string,
    public readonly order: TableSortOrderType,
  ) {}
}
